export const SET_USER_DATA = "setUserData";

export const setUserData = (payload: any) => {
  return {
    type: SET_USER_DATA,
    payload,
  };
};
